import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'customer',
  initialState: {
    delivery_address: [],
    invoice_address: [],
    store_address: [],
    ktp_address: {},
    npwp_address: {},
    detail: {},
  },
  reducers: {
    setDeliveryAddress: (state, action) => {
      state.delivery_address = action.payload;
    },
    setInvoiceAddress: (state, action) => {
      state.invoice_address = action.payload;
    },
    setKtpAddress: (state, action) => {
      state.ktp_address = action.payload;
    },
    setNpwpAddress: (state, action) => {
      state.npwp_address = action.payload;
    },
    setStoreAddress: (state, action) => {
      state.store_address = action.payload;
    },
    setDetail: (state, action) => {
      state.detail = action.payload;
    },
    reset: (state, action) => {
      state.detail = {};
      state.delivery_address = [];
      state.invoice_address = [];
      state.ktp_address = {};
      state.npwp_address = {};
      state.store_address = [];
    },
  },
});

export const {
  setDeliveryAddress,
  setInvoiceAddress,
  setKtpAddress,
  setNpwpAddress,
  setStoreAddress,
  setDetail,
  reset,
} = slice.actions;

export default slice.reducer;
